export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const ADD_AUTH_DATA = 'ADD_AUTH_DATA';
export const DELETE_AUTH_DATA = 'DELETE_AUTH_DATA';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const DELETE_PICTURE = 'DELETE_PICTURE';




// WEBPACK FOOTER //
// ./src/store/modules/auth/action-types.js